// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

/* Assuming \`gizmo-shadow-stroke\` is a custom class */
.gizmo-shadow-stroke {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.flex {
  display: flex;
}

.h-6 {
  height: 1.5rem; /* 24px */
}

.w-6 {
  width: 1.5rem; /* 24px */
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.overflow-hidden {
  overflow: hidden;
}

.rounded-full {
  border-radius: 9999px;
}

.w-full {
  width: 100%;
}

.text-token-text-primary {
  color: var(--token-text-primary);
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.justify-center {
  justify-content: center;
}

.text-base {
  font-size: 1rem;
}

.md\\:gap-6 {
  gap: 1.5rem; /* 24px */
}

.m-auto {
  margin: auto;
}

.flex-1 {
  flex: 1;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.gap-3 {
  gap: 0.75rem; /* 12px */
}

.md\\:px-5 {
  padding-left: 1.25rem; /* 20px */
  padding-right: 1.25rem; /* 20px */
}

.lg\\:px-1 {
  padding-left: 0.25rem; /* 4px */
  padding-right: 0.25rem; /* 4px */
}

.xl\\:px-5 {
  padding-left: 1.25rem; /* 20px */
  padding-right: 1.25rem; /* 20px */
}

.md\\:max-w-3xl {
  max-width: 48rem; /* 768px */
}

.lg\\:max-w-\\[40rem\\] {
  max-width: 40rem; /* 640px */
}

.xl\\:max-w-\\[48rem\\] {
  max-width: 48rem; /* 768px */
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.relative {
  position: relative;
}

.items-end {
  align-items: flex-end;
}

.pt-0\\.5 {
  padding-top: 0.125rem; /* 2px */
}

.w-6 {
  width: 1.5rem; /* 24px */
}

.h-6 {
  height: 1.5rem; /* 24px */
}

.rounded-sm {
  border-radius: 0.125rem; /* 2px */
}

.font-semibold {
  font-weight: 600;
}

.select-none {
  user-select: none;
}

.flex-col {
  flex-direction: column;
}

.gap-1 {
  gap: 0.25rem; /* 4px */
}

.md\\:gap-3 {
  gap: 0.75rem; /* 12px */
}

.flex-grow {
  flex-grow: 1;
}

.max-w-full {
  max-width: 100%;
}

.min-h-\\[20px\\] {
  min-height: 20px;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.break-words {
  word-break: break-word;
}

.overflow-x-auto {
  overflow-x: auto;
}

.space-x-2 {
  margin-left: -0.5rem; /* -8px */
  & > :not([hidden]) ~ :not([hidden]) {
    margin-left: 0.5rem; /* 8px */
  }
}

.mt-1 {
  margin-top: 0.25rem; /* 4px */
}

.text-sm {
  font-size: 0.875rem; /* 14px */
}

.text-token-text-secondary {
  color: var(--token-text-secondary);
}

.tradegpt-widget {
  border-radius: 10px;
  border: 1px solid #E4E5E8;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  overflow: hidden;
}

.tradegpt-widget__sidebar {
  display: flex;
  width: 255px;
  height: auto;
  padding: 20px 24px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
  background-image: url("https://ta-image-hosting.s3.us-east-2.amazonaws.com/black.jpg");
  background-size: 100% 100%;
}

.tradegpt-widget__sidebar__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.tradegpt-widget__sidebar__header__title {
  color: #FFF;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.072px;
}

.tradegpt-widget__sidebar__header__splitter {
  width: 27px;
  height: 1px;
  background: #FFFFFF;
}

.tradegpt-widget__sidebar__content {
  width: 100%;
  height: 100%;
}

.tradegpt-widget__sidebar__content__title {
  color: #FFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.06px;
  margin-bottom: 10px;
}

.tradegpt-widget__sidebar__content__prompts {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  height: calc(100% - 31px);
  max-height: 250px;
  overflow: auto;
}

.tradegpt-widget__sidebar__content__prompts::-webkit-scrollbar {
  display: none;
}

.tradegpt-widget__sidebar__content__prompt {
  border-radius: 10px;
  border: 1px solid #CCC;
  padding: 10px 16px;
  color: #CCC;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.01px;
  width: 100%;
  cursor: pointer;
}

.tradegpt-widget__content {
  width: calc(100% - 255px);
  padding: 20px 24px 8px 24px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 20px;
}

.tradegpt-widget__content__messages {
  height: calc(100% - 100px);
  min-width: 100%;
  max-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  overflow: auto;
}

.tradegpt-widget__content__messages> :first-child {
  margin-top: auto;
  flex-direction: column;
}

.tradegpt-widget__content__messages::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
.tradegpt-widget__content__messages::-webkit-scrollbar-track {
  background: #F8FAFC;
}

body.dark .tradegpt-widget__content__messages::-webkit-scrollbar-track {
  background: #000;
}

/* Handle */
.tradegpt-widget__content__messages::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.tradegpt-widget__content__messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.tradegpt-widget__content__message {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px 0 0;
  gap: 6px;
  width: 100%;
}

.tradegpt-widget__content__message__avatar img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.tradegpt-widget-username {
  color: #007BFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.06px;
}

.tradegpt-widget-username.tradegpt-widget-bot-name {
  color: #000;
}

.tradegpt-widget__content__message__text {
  color: #A6A6A6;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.06px;
  width: 100%;
}

.custom-tradegpt-widget-message-content {
  width: calc(100% - 24px - 0.75rem) !important;
}

.tradegpt-widget__content__message__action_icons {
  margin-top: 4px;
}

.tradegpt-widget__content__message__action_icons svg {
  cursor: pointer;
}

.tradegpt-widget__content__footer__input__send-icon {
  position: absolute !important;
  border-radius: 8px !important;
  background: #1C1C1E !important;
  padding: 6px !important;
  cursor: pointer !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  right: 4px !important;
  width: 36px !important;
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.tradegpt-widget__content__footer__input__send-icon:disabled {
  background-color: rgb(166, 166, 166)!important; ;
}

.tradegpt-widget__content__footer {
  width: 100%;
}

.tradegpt-widget__content__footer__input {
  position: relative;
  width: 100%;
  border-radius: 6px;
  background: #F5F5F5;
  padding: 8px 8px 8px 12px;
  height: 44px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

input.tradegpt-widget-query-input {
  color: #A6A6A6;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: transparent;
  border: none;
  outline: none;
  width: calc(100% - 50px);
}

.tradegpt-widget__content__footer__hint {
  color: #A3A3A3;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px;
}

.tradegpt-widget__content__footer__dragger {
  border-radius: 100px;
  background: #E4E5E8;
  width: 134px;
  margin: 0 auto;
  height: 5px;
}

.tradegpt-widget__content__get_started {
  margin-top: 10px;
  width: 100%;
  padding-bottom: 10px;
}

.tradegpt-widget__content__get_started__title {
  color: #007BFF;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.052px;
  margin-bottom: 4px;
}

.tradegpt-widget__content__get_started__items {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.tradegpt-widget__content__get_started__item {
  border-radius: 16px;
  border: 1px solid #E4E5E8;
  padding: 10px 16px;
  width: calc((100% - 20px) / 3);
  cursor: pointer;
}

.tradegpt-widget__content__get_started__item__title {
  color: #1C1C1E;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.01px;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
}

.tradegpt-widget__content__get_started__item__description {
  overflow: hidden;
  color: #A3A3A3;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.01px;
  text-wrap: nowrap;
}

.tradegpt-widget__content__message__text p, .tradegpt-widget__content__message__text ul {
  margin: 0;
}

.tradegpt-widget-message-action {
  background: transparent;
  border: none;
}

.tradegpt-widget-message-action.invisible-button {
  display: none;
}

.tradegpt-widget-message-action svg {
  width: 18px;
  height: 18px;
  fill: #000;
}
`, "",{"version":3,"sources":["webpack://./lib/assets/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,uEAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,SAAS;AAC3B;;AAEA;EACE,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,SAAS;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,SAAS;AACzB;;AAEA;EACE,qBAAqB,EAAE,SAAS;EAChC,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE,qBAAqB,EAAE,QAAQ;EAC/B,sBAAsB,EAAE,QAAQ;AAClC;;AAEA;EACE,qBAAqB,EAAE,SAAS;EAChC,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE,gBAAgB,EAAE,UAAU;AAC9B;;AAEA;EACE,gBAAgB,EAAE,UAAU;AAC9B;;AAEA;EACE,gBAAgB,EAAE,UAAU;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB,EAAE,QAAQ;AACjC;;AAEA;EACE,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,cAAc,EAAE,SAAS;AAC3B;;AAEA;EACE,uBAAuB,EAAE,QAAQ;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,QAAQ;AACxB;;AAEA;EACE,YAAY,EAAE,SAAS;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB,EAAE,SAAS;EAC/B;IACE,mBAAmB,EAAE,QAAQ;EAC/B;AACF;;AAEA;EACE,mBAAmB,EAAE,QAAQ;AAC/B;;AAEA;EACE,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ","sourcesContent":["* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Assuming `gizmo-shadow-stroke` is a custom class */\r\n.gizmo-shadow-stroke {\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n.h-6 {\r\n  height: 1.5rem; /* 24px */\r\n}\r\n\r\n.w-6 {\r\n  width: 1.5rem; /* 24px */\r\n}\r\n\r\n.items-center {\r\n  align-items: center;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.rounded-full {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.text-token-text-primary {\r\n  color: var(--token-text-primary);\r\n}\r\n\r\n.px-4 {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.py-2 {\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center;\r\n}\r\n\r\n.text-base {\r\n  font-size: 1rem;\r\n}\r\n\r\n.md\\:gap-6 {\r\n  gap: 1.5rem; /* 24px */\r\n}\r\n\r\n.m-auto {\r\n  margin: auto;\r\n}\r\n\r\n.flex-1 {\r\n  flex: 1;\r\n}\r\n\r\n.mx-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.gap-3 {\r\n  gap: 0.75rem; /* 12px */\r\n}\r\n\r\n.md\\:px-5 {\r\n  padding-left: 1.25rem; /* 20px */\r\n  padding-right: 1.25rem; /* 20px */\r\n}\r\n\r\n.lg\\:px-1 {\r\n  padding-left: 0.25rem; /* 4px */\r\n  padding-right: 0.25rem; /* 4px */\r\n}\r\n\r\n.xl\\:px-5 {\r\n  padding-left: 1.25rem; /* 20px */\r\n  padding-right: 1.25rem; /* 20px */\r\n}\r\n\r\n.md\\:max-w-3xl {\r\n  max-width: 48rem; /* 768px */\r\n}\r\n\r\n.lg\\:max-w-\\[40rem\\] {\r\n  max-width: 40rem; /* 640px */\r\n}\r\n\r\n.xl\\:max-w-\\[48rem\\] {\r\n  max-width: 48rem; /* 768px */\r\n}\r\n\r\n.flex-shrink-0 {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.items-end {\r\n  align-items: flex-end;\r\n}\r\n\r\n.pt-0\\.5 {\r\n  padding-top: 0.125rem; /* 2px */\r\n}\r\n\r\n.w-6 {\r\n  width: 1.5rem; /* 24px */\r\n}\r\n\r\n.h-6 {\r\n  height: 1.5rem; /* 24px */\r\n}\r\n\r\n.rounded-sm {\r\n  border-radius: 0.125rem; /* 2px */\r\n}\r\n\r\n.font-semibold {\r\n  font-weight: 600;\r\n}\r\n\r\n.select-none {\r\n  user-select: none;\r\n}\r\n\r\n.flex-col {\r\n  flex-direction: column;\r\n}\r\n\r\n.gap-1 {\r\n  gap: 0.25rem; /* 4px */\r\n}\r\n\r\n.md\\:gap-3 {\r\n  gap: 0.75rem; /* 12px */\r\n}\r\n\r\n.flex-grow {\r\n  flex-grow: 1;\r\n}\r\n\r\n.max-w-full {\r\n  max-width: 100%;\r\n}\r\n\r\n.min-h-\\[20px\\] {\r\n  min-height: 20px;\r\n}\r\n\r\n.overflow-y-hidden {\r\n  overflow-y: hidden;\r\n}\r\n\r\n.break-words {\r\n  word-break: break-word;\r\n}\r\n\r\n.overflow-x-auto {\r\n  overflow-x: auto;\r\n}\r\n\r\n.space-x-2 {\r\n  margin-left: -0.5rem; /* -8px */\r\n  & > :not([hidden]) ~ :not([hidden]) {\r\n    margin-left: 0.5rem; /* 8px */\r\n  }\r\n}\r\n\r\n.mt-1 {\r\n  margin-top: 0.25rem; /* 4px */\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem; /* 14px */\r\n}\r\n\r\n.text-token-text-secondary {\r\n  color: var(--token-text-secondary);\r\n}\r\n\r\n.tradegpt-widget {\r\n  border-radius: 10px;\r\n  border: 1px solid #E4E5E8;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: flex-start;\r\n  overflow: hidden;\r\n}\r\n\r\n.tradegpt-widget__sidebar {\r\n  display: flex;\r\n  width: 255px;\r\n  height: auto;\r\n  padding: 20px 24px;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 15px;\r\n  flex-shrink: 0;\r\n  background-image: url(\"https://ta-image-hosting.s3.us-east-2.amazonaws.com/black.jpg\");\r\n  background-size: 100% 100%;\r\n}\r\n\r\n.tradegpt-widget__sidebar__header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n}\r\n\r\n.tradegpt-widget__sidebar__header__title {\r\n  color: #FFF;\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 25px;\r\n  letter-spacing: -0.072px;\r\n}\r\n\r\n.tradegpt-widget__sidebar__header__splitter {\r\n  width: 27px;\r\n  height: 1px;\r\n  background: #FFFFFF;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__title {\r\n  color: #FFF;\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  letter-spacing: -0.06px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n  height: calc(100% - 31px);\r\n  max-height: 250px;\r\n  overflow: auto;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompts::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompt {\r\n  border-radius: 10px;\r\n  border: 1px solid #CCC;\r\n  padding: 10px 16px;\r\n  color: #CCC;\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget__content {\r\n  width: calc(100% - 255px);\r\n  padding: 20px 24px 8px 24px;\r\n  background: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-end;\r\n  gap: 20px;\r\n}\r\n\r\n.tradegpt-widget__content__messages {\r\n  height: calc(100% - 100px);\r\n  min-width: 100%;\r\n  max-height: 300px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  width: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.tradegpt-widget__content__messages> :first-child {\r\n  margin-top: auto;\r\n  flex-direction: column;\r\n}\r\n\r\n.tradegpt-widget__content__messages::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n/* Track */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-track {\r\n  background: #F8FAFC;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__messages::-webkit-scrollbar-track {\r\n  background: #000;\r\n}\r\n\r\n/* Handle */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.tradegpt-widget__content__message {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding: 0 20px 0 0;\r\n  gap: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__content__message__avatar img {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.tradegpt-widget-username {\r\n  color: #007BFF;\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 22px;\r\n  letter-spacing: -0.06px;\r\n}\r\n\r\n.tradegpt-widget-username.tradegpt-widget-bot-name {\r\n  color: #000;\r\n}\r\n\r\n.tradegpt-widget__content__message__text {\r\n  color: #A6A6A6;\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n  letter-spacing: -0.06px;\r\n  width: 100%;\r\n}\r\n\r\n.custom-tradegpt-widget-message-content {\r\n  width: calc(100% - 24px - 0.75rem) !important;\r\n}\r\n\r\n.tradegpt-widget__content__message__action_icons {\r\n  margin-top: 4px;\r\n}\r\n\r\n.tradegpt-widget__content__message__action_icons svg {\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input__send-icon {\r\n  position: absolute !important;\r\n  border-radius: 8px !important;\r\n  background: #1C1C1E !important;\r\n  padding: 6px !important;\r\n  cursor: pointer !important;\r\n  top: 50% !important;\r\n  transform: translateY(-50%) !important;\r\n  right: 4px !important;\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input__send-icon:disabled {\r\n  background-color: rgb(166, 166, 166)!important; ;\r\n}\r\n\r\n.tradegpt-widget__content__footer {\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input {\r\n  position: relative;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  background: #F5F5F5;\r\n  padding: 8px 8px 8px 12px;\r\n  height: 44px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\ninput.tradegpt-widget-query-input {\r\n  color: #A6A6A6;\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  background: transparent;\r\n  border: none;\r\n  outline: none;\r\n  width: calc(100% - 50px);\r\n}\r\n\r\n.tradegpt-widget__content__footer__hint {\r\n  color: #A3A3A3;\r\n  text-align: center;\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 16px;\r\n  padding: 8px;\r\n}\r\n\r\n.tradegpt-widget__content__footer__dragger {\r\n  border-radius: 100px;\r\n  background: #E4E5E8;\r\n  width: 134px;\r\n  margin: 0 auto;\r\n  height: 5px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started {\r\n  margin-top: 10px;\r\n  width: 100%;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__title {\r\n  color: #007BFF;\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  letter-spacing: -0.052px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__items {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item {\r\n  border-radius: 16px;\r\n  border: 1px solid #E4E5E8;\r\n  padding: 10px 16px;\r\n  width: calc((100% - 20px) / 3);\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item__title {\r\n  color: #1C1C1E;\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  text-overflow: ellipsis;\r\n  text-wrap: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item__description {\r\n  overflow: hidden;\r\n  color: #A3A3A3;\r\n  text-overflow: ellipsis;\r\n  font-family: Inter;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.tradegpt-widget__content__message__text p, .tradegpt-widget__content__message__text ul {\r\n  margin: 0;\r\n}\r\n\r\n.tradegpt-widget-message-action {\r\n  background: transparent;\r\n  border: none;\r\n}\r\n\r\n.tradegpt-widget-message-action.invisible-button {\r\n  display: none;\r\n}\r\n\r\n.tradegpt-widget-message-action svg {\r\n  width: 18px;\r\n  height: 18px;\r\n  fill: #000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
